// Liste unifiée des extensions et mimetypes autorisés côté front pour les uploads de documents
// Doit rester synchronisée avec `gateway/src/common/file-upload/file-upload.filter.ts`

export const DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
  "application/vnd.oasis.opendocument.text", // odt
  "application/vnd.oasis.opendocument.spreadsheet", // ods
  "image/png",
  "image/x-png", // alternative PNG MIME type (Windows/older tools)
  "image/jpeg",
  "image/webp",
  "image/gif",
  "image/bmp",
  "image/x-ms-bmp",
  "image/x-bmp",
  "image/tiff",
  "image/x-tiff",
  "text/plain", // txt
  "text/csv", // csv
];

// Extensions (gardées pour compatibilité si besoin)
export const DOCUMENT_EXTENSIONS = [
  ".pdf",
  ".docx",
  ".xlsx",
  ".odt",
  ".ods",
  ".png",
  ".jpeg",
  ".jpg",
  ".webp",
  ".gif",
  ".bmp",
  ".tif",
  ".tiff",
  ".txt",
  ".csv",
];

// Combiné MIME types + extensions pour l'attribut accept du <input type="file">
// Les extensions améliorent la compatibilité sur Windows où les MIME types seuls peuvent être ignorés
export const DOCUMENT_ACCEPT = [
  ...DOCUMENT_MIME_TYPES,
  ...DOCUMENT_EXTENSIONS,
].join(",");
